import { Component, Input, Output, EventEmitter, SimpleChange, ChangeDetectionStrategy, ChangeDetectorRef, OnChanges, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { Util, UserInterface } from '../utils/utils.module';
import { BaseDesc } from '../models/base';
import { CommandHandler } from '../models/command-handler';
import { LocalizeService } from '../services/localize.service';
import { SelectItem } from '../models/form-field';
import { AdminService } from '../services/admin.service';

@Component({
  selector: 'edx-window-modal-header',
  styleUrls: ['window-modal.component.scss', 'window-modal-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="window-modal-header">
      @if (ui<2) {
        <img role="button" class="icon contractor" [src]="iconUrl" [title]="closeStr" [alt]="closeStr + ' ' + title" (mouseover)="showContract($event)" (focus)="showContract($event)" (focusout)="hideContract($event)" (mouseleave)="hideContract($event)" tabindex="11" (click)="contract($event)" (keyup.enter)="contract($event)" (keyup.space)="contract($event)">
      }
      @if (ui>=2) {
        <img class="icon" [src]="iconUrl" (click)="contract($event)" [alt]="closeStr + title">
      }
      <h1 class="window-modal-header-title" [ngClass]="{mobile:ui>=2}" title="{{title}}">{{title}}</h1>
      @if (filtered) {
        <div class="filtericon" tabindex="13"></div>
      }
      @if (menuID!=0) {
        <div class="window-modal-header-menu">
          <edx-menu [menuID]="menuID" [callback]="parent" [hideIfEmpty]="true" [rerender]="rerender" [tabIndex]="12"></edx-menu>
        </div>
      }
      <div class="right-section">
        @if (isAdminPage()) {
          <div class="library">
            <div class="library-section">
              <label class="library-label"  [ngClass]="{disabled:!areHeaderButtonsDisabled}">{{forLibStr}}</label>
              <edx-select [id]="'edx_admin_libsel_item'" [ariaLabel]="forLibStr" [items]="libraries"
              [value]="!!desc?desc.lib:''" [disabled] = "!areHeaderButtonsDisabled" (change)="libraryChanged($event)"></edx-select>
            </div>
          </div>
        }
        @if (!!rightBtn) {
          <button tabindex="15" class="save-search-button secondary" [ngClass]="{mobile:ui>=2, oai:isAddin, readonly:areHeaderButtonsDisabled}" [title]="rightBtn" (click)="rightHdrBtnClick.emit()" (keyup.enter)="rightHdrBtnClick.emit()" (keyup.space)="rightHdrBtnClick.emit()" [disabled] = "areHeaderButtonsDisabled">{{rightBtn}}</button>
        }
        @if (showCancel) {
          <button tabindex="14" class="save-search-button secondary" [ngClass]="{mobile:ui>=2, oai:isAddin, readonly:areHeaderButtonsDisabled}" [title]="cancelStr" (click)="cancelHdrBtnClick.emit()" (keyup.enter)="cancelHdrBtnClick.emit()" (keyup.space)="cancelHdrBtnClick.emit()" [disabled] = "areHeaderButtonsDisabled">{{cancelStr}}</button>
        }
      </div>
    </div>
    `,
  standalone: false
})
export class WindowModalHeaderComponent implements OnChanges, OnDestroy {
  public iconUrl: string;
  public ui: UserInterface;
  public isAddin: boolean;
  private reloadStr = '';
  private closeStr = '';
  private cancelStr = '';
  public forLibStr: string;
  @Output() rightHdrBtnClick: EventEmitter<void> = new EventEmitter();
  @Output() cancelHdrBtnClick: EventEmitter<void> = new EventEmitter();
  @Output() libraryChangeEvent: EventEmitter<void> = new EventEmitter();
  @Input() parent: CommandHandler;
  @Input() title: string;
  @Input() desc: BaseDesc;
  @Input() menuID?: number = 0;
  @Input() filtered = false;
  @Input() rightBtn: string = null;
  @Input() showCancel = false;
  @Input() rerender = 0;
  @Input() libraries: SelectItem[];
  @Input() areHeaderButtonsDisabled: boolean;

  constructor(protected location: Location, private cdr: ChangeDetectorRef, private localizer: LocalizeService, public adminService: AdminService) {
    this.reloadStr = this.localizer.getTranslation('FOLDER_ACTIONS.RELOAD');
    this.closeStr = this.localizer.getTranslation('FORMS.BUTTONS.CLOSE');
    this.cancelStr = this.localizer.getTranslation('FORMS.BUTTONS.CANCEL');
    this.ui = Util.Device.ui;
    this.isAddin = Util.Device.bIsAddin;
    this.forLibStr = this.localizer.getTranslation('FORMS.LOCAL.PREFERENCES.FOR_LIB_SHORT');
  }

  ngOnDestroy(): void {
    this.libraries = [];
  }

  ngOnChanges(changes: { [propertyName: string]: SimpleChange }): void {
    const chng: any = changes['desc'];
    if (chng) {
      this.iconUrl = Util.Transforms.titleIconUrlFromDesc(this.desc);
      this.rerender++;
    }
  }

  private showContract(event: MouseEvent): void {
    this.iconUrl = 'assets/images/minimize.svg';
  }

  private hideContract(event: MouseEvent): void {
    this.iconUrl = Util.Transforms.tileIconUrlFromDesc(this.desc);
  }

  private contract(event: MouseEvent): void {
    if (this.ui < 2) {
      Util.RestAPI.navBack();
    }
  }

  public libraryChanged(event): void {
    this.libraryChangeEvent.emit(event);
  }

  public isAdminPage(): boolean {
    return Util.RestAPI.isAdminPage();
  }
}
